<nx-pageTitle-box class="mb-3" [label]="'rentModule.locationsListComponent.pageTitle.label' | translate" [icon]="'icon-branches'" [iconToolTip]="'rentModule.locationsListComponent.pageTitle.iconTooltip' | translate"
  [bcRootLvlLabel]="'rentModule.locationsListComponent.pageTitle.bcRootLvlLabel' | translate"
  [bcRootLvlPath]="'settings'">
</nx-pageTitle-box>

<nx-table-header
  [label]="'rentModule.locationsListComponent.tableHeader.label' | translate">
  <ng-template nxTemplate="end">
    <nx-default-button
      *ngIf="rolesService.hasRole('nexcore_location_create')"
      [style]="'light'"
      (click)="createLocation()"
      [label]="'rentModule.locationsListComponent.tableHeader.createButton' | translate"
      [icon]="'icon-plus'">
    </nx-default-button>
  </ng-template>
</nx-table-header>
  
<p-table
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [value]="dataSource?.data"
  [scrollable]="true"
  [paginator]="true"
  [rows]="15"
  [rowsPerPageOptions]="[15, 20, 50]"
  [totalRecords]="dataSource?.totalElements"
  [loading]="loading"
  [sortField]="sortProperty" 
  [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
  
  [showCurrentPageReport]="true"
  [currentPageReportTemplate]="'rentModule.locationsListComponent.table.pagination' | translate"
  [resizableColumns]="true">
  <ng-template pTemplate="caption">
    <div class="flex flex-row">
      <div class="basis-2/3 flex flex-row gap-2">
        <!-- no filter -->
      </div>
      <div class="basis-1/3 flex flex-row justify-end">
        <p-dropdown
          [placeholder]="'rentModule.locationsListComponent.sorting.placeholder' | translate"
          [styleClass]="'sort'"
          appendTo="body"
          [ngModel] = "sortModel"
          [options]="sortOptions | arrayTranslate"
          optionLabel="label"
          [showClear]="false"
          (onChange)="sort($event)">
          <ng-template let-option pTemplate="item">
            <div>{{option.label | translate}}</div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th>{{'rentModule.locationsListComponent.table.header.name' | translate}}</th>
    </tr>
    </ng-template>
    <ng-template pTemplate="body" let-location>
        <tr class="clickable" (click)="editLocation(location)">
            <td>{{location.name}}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="1" class="emptyMessage">{{'rentModule.locationsListComponent.table.emptyMessage' | translate}}</td>
      </tr>
    </ng-template>
  </p-table>

